import React from 'react';
import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';

type Props = {
  onClick: () => void;
  totalAmount: string;
  disabled?: boolean;
};

const PayButton: React.FC<Props> = ({ onClick, totalAmount, disabled }) => {
  const { formatMessage } = useIntl();
  return (
    <Button variant="contained" onClick={onClick} disabled={disabled}>
      {formatMessage(
        { id: 'payment.footer.actionButton.pay', defaultMessage: `Pay ${totalAmount}` },
        { sum: totalAmount },
      )}
    </Button>
  );
};

export default PayButton;
